import { useEffect, useRef, useState } from "react";
import { SendHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";

export function HelpComposer({ disabled, onSend }) {
  const [text, setText] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    if (window.innerWidth >= 768) ref.current?.focus();
  }, []);
  const send = () => {
    if (!text.trim() || disabled) return;
    onSend(text);
    setText("");
  };
  return (
    <form onSubmit={(e) => { e.preventDefault(); send(); }} className="flex items-end gap-2 border-t bg-card p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
      <textarea ref={ref} rows={1} value={text} maxLength={300} onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
        placeholder="Digite sua dúvida..." aria-label="Digite sua dúvida"
        className="max-h-28 min-h-[44px] flex-1 resize-none rounded-xl border bg-background px-3 py-2.5 text-sm outline-none transition-shadow placeholder:text-muted-foreground focus:ring-2 focus:ring-primary/40"
        data-testid="help-input" />
      <Button type="submit" size="icon" className="h-11 w-11 shrink-0 rounded-xl" disabled={disabled || !text.trim()} aria-label="Enviar" data-testid="help-send-btn">
        <SendHorizontal className="h-5 w-5" />
      </Button>
    </form>
  );
}
